import { render } from "./NavigationPanel.vue?vue&type=template&id=af606220"
import script from "./NavigationPanel.vue?vue&type=script&lang=js"
export * from "./NavigationPanel.vue?vue&type=script&lang=js"

import "./NavigationPanel.vue?vue&type=style&index=0&id=af606220&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__